<div class="pull-right mr-2 mt-2">
  <ngx-help-icon videoLink="https://www.loom.com/share/5bc7212212ae4e16ac910896dcfbee5c"></ngx-help-icon>
</div>
<div class="container-fluid p-4">
  <div class="row" *ngIf="!isReducedView">
    <div class="col">
      <h2>{{isRCDSS ? 'New Contract' : 'New Simple Purchase Order'}} <span *ngIf="purchaseOrder?.customer_po_number">#
          {{ purchaseOrder.customer_po_number }}</span>
      </h2>
    </div>
  </div>

  <div class="rounded shadow p-4 bg-white mt-4" [formGroup]="purchaseOrderForm">
    <mat-horizontal-stepper [linear]="true" #stepper="matHorizontalStepper">
      <mat-step label="Basic Information" [completed]="!!purchaseOrder?.id">
        <div class="row">
          <div [ngClass]="{
            'col-md-12': isReducedView,
            'col-md-5': !isReducedView,
            'offset-md-2': isRCDSS
          }">

            <div class="row">
              <div class="col" *ngIf="!isReducedView">
                <mat-form-field>
                  <input type="text" matInput
                    [placeholder]="isRCDSS ? 'Contract number' : 'Purchase Order / Contract number'"
                    formControlName="customer_po_number" required />
                  <mat-error *ngIf="purchaseOrderForm.controls.customer_po_number.errors?.exists">
                    This number is already registered
                  </mat-error>
                  <mat-error *ngIf="!purchaseOrderForm.controls.customer_po_number.value">
                    This field is required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="col">
                <ng-select ngEditableSelect labelForId="supplier_select" #supplier_select [items]="suppliers"
                  bindValue="id" bindLabel="name" placeholder="Supplier *" required appendTo="body" [clearable]="false"
                  [minlength]="2" typeToSearchText="Please enter 2 or more characters" formControlName="supplier_id">
                  <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                    <div [ngOptionHighlight]="search">
                      {{ item.name }}
                    </div>
                  </ng-template>
                  <ng-template ng-footer-tmp>
                    <a class="d-block" (click)="addNewCompany(); supplier_select.close();">
                      Add new company
                    </a>
                  </ng-template>
                </ng-select>
              </div>
              <div class="col-12" *ngIf="isSimpleFlow && !isReducedView && !isRCDSS">
                <mat-form-field>
                  <mat-select placeholder="Approver" formControlName="approver_id"
                    matTooltip="Picking 'No Approver' will create the Purchase Order in an Open status, therefore your supplier will not need to approve it and will not receive the approval email notification."
                    [disabled]="!purchaseOrderForm.controls.supplier_id.value">
                    <mat-option value="00000000-0000-0000-0000-000000000000">No Approver</mat-option>
                    <mat-option *ngFor="let user of supplierUsers" [value]="user.id">{{ user.first_name }} {{
                      user.last_name }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12">
                <mat-form-field>
                  <input type="text" matInput [placeholder]="'Program'" formControlName="rcdss_contract_program" />
                  <!-- <mat-error *ngIf="!purchaseOrderForm.controls.rcdss_contract_program.value">
                    This field is required
                  </mat-error> -->
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-md-7" *ngIf="!isReducedView && !isRCDSS">
            <ngx-title-divider title="Files" [bold]="true"></ngx-title-divider>
            <ngx-files-step [purchaseOrder]="purchaseOrder" [(poFiles)]="poFiles" [isSimpleFlow]="true"
              (discard)="deletePoDraft()" (saveDraft)="savePODraft()"></ngx-files-step>
          </div>
          <div class="col-md-3">
            <div class="card mb-2">
              <div class="card-body">
                <h5 class="card-title">Notification Settings</h5>

                <div class="row">
                  <div class="col-12 p-2" *ngFor="let subscriber of subscribers">
                    <div class="border p-2">
                      <span>{{ subscriber.first_name | titlecase }} {{ subscriber.last_name | titlecase }}</span>
                      <br>
                      <small>{{ subscriber.email }}</small>
                    </div>
                  </div>
                </div>

                <button type="button" [disabled]="purchaseOrderForm.invalid" class="btn btn-primary text-white"
                  (click)="openSubscribersModal()">Edit
                </button>

              </div>
            </div>

          </div>
        </div>

        <ngx-title-divider class="optional" title="Optional" *ngIf="!isReducedView && !isRCDSS"></ngx-title-divider>

        <div class="row" *ngIf="!isReducedView && !isRCDSS">
          <div class="col-3">
            <div class="card mb-2">
              <div class="card-body">
                <h5 class="card-title">Task List</h5>
                <div *ngIf="checklist?.checklist_tasks">
                  <div class="border p-2 mb-1" *ngFor="let task of checklist.checklist_tasks">
                    <span [style.font-size.px]=14>{{ task.name }}</span>
                    <div>
                      <span><u>Responsible:</u> {{ task.responsible_contact?.first_name | titlecase }} {{
                        task.responsible_contact?.last_name | titlecase }}</span>
                      <span><u>Due Date:</u> {{ task.due_date | date:'MMM dd yyyy':'utc' }}</span>
                    </div>
                  </div>
                </div>

                <button type="button" [disabled]="!purchaseOrder?.id" class="btn btn-primary text-white"
                  (click)="openTaskListModal()">Add Tasks
                </button>

              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="card mb-2">
              <div class="card-body">
                <h5 class="card-title">Subscribers</h5>

                <div class="row">
                  <div class="col-12 p-2" *ngFor="let subscriber of subscribers">
                    <div class="border p-2">
                      <span>{{ subscriber.first_name | titlecase }} {{ subscriber.last_name | titlecase }}</span>
                      <br>
                      <small>{{ subscriber.email }}</small>
                    </div>
                  </div>
                </div>

                <button type="button" [disabled]="purchaseOrderForm.invalid" class="btn btn-primary text-white"
                  (click)="openSubscribersModal()">Add Subscribers
                </button>

              </div>
            </div>

          </div>

          <div class="col-3" *ngIf="!isRCDSS">
            <div class="card mb-2">
              <div class="card-body">
                <h5 class="card-title">Shipments</h5>

                <div class="row" *ngIf="shipments">
                  <div class="col-12 p-2" *ngFor="let shipment of shipments">
                    <div class="border p-2">
                      <span>{{ shipment.enhanced_tracking_identifier }}</span>
                    </div>
                  </div>
                </div>

                <button type="button" [disabled]="purchaseOrderForm.invalid" class="btn btn-primary text-white"
                  (click)="addShipmentsModal()">Add Shipment
                </button>

              </div>
            </div>
          </div>
          <div class="col-3" *ngIf="!isRCDSS">
            <mat-form-field>
              <input matInput [matDatepicker]="shipDatePicker" placeholder="Ship date" formControlName="ship_date"
                [min]="purchaseOrderForm.controls.order_date.value" (click)="shipDatePicker.open()" readonly />
              <mat-datepicker-toggle matSuffix [for]="shipDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #shipDatePicker title="Select an order date first"></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
              <input matInput [matDatepicker]="cancelDatePicker" placeholder="Cancel Date" formControlName="cancel_date"
                [min]="purchaseOrderForm.controls.ship_date.value" (click)="cancelDatePicker.open()" readonly />
              <mat-datepicker-toggle matSuffix [for]="cancelDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #cancelDatePicker title="Select a ship date first"></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="row" *ngIf="!canSupplierReceivePos && !isReducedView">
          <div class="col-md-12">
            <div class="alert alert-warning mb-2 mt-2">
              <i class="fa fa-warning"></i> The selected supplier has not provided one or more of the Customer-Required
              Files defined by your company. You can keep editing this Purchase Order and save it as a draft, but you
              won't be able to issue it until your supplier fills all file requirements.
            </div>
          </div>
        </div>

        <div class="d-flex mt-4 p-2 justify-content-center align-items-center position-relative" *ngIf="!isReducedView">
          <!-- <button  class="ml-1 mr-1" type="button" mat-raised-button color="grey"
            (click)="importExcel()" [disabled]="isSaving">
            Import Excel
          </button> -->

          <!-- <input type="file" id='fileInput' style="display: none" (change)="onFileChange($event)" /> -->

          <button *ngIf="!isRCDSS" class="ml-1 mr-1" type="button" mat-raised-button color="grey"
            (click)="savePODraft(true)" [disabled]="isSaving || !canSupplierReceivePos || !purchaseOrder">
            Save to Draft
          </button>
          <button class="ml-1 mr-1" type="button" mat-raised-button color="primary"
            [disabled]="isSaving || !canSupplierReceivePos" (click)="createPO()">
            {{isRCDSS ? 'Create Contract' : 'Send to Supplier'}}
          </button>

          <button class="ml-1 mr-1 button-discard" type="button" mat-raised-button color="warn"
            (click)="deletePoDraft()">
            Discard
          </button>
        </div>

      </mat-step>
    </mat-horizontal-stepper>
  </div>

</div>